enum MeshType {
  PLY = 'PLY',
  STL = 'STL',
  OBJ = 'OBJ',
  VTP = 'VTP',
}

export default MeshType;
